import actionTypes from '../actionTypes';
import enrichDataObject from 'src/utils/enrichDataObject';
import api, { createAuthenticatedApiInstance } from 'src/utils/api';
import { setAlert } from 'src/typescript/components/alert/actions';
import * as log from 'loglevel';

export const fetchPost = (postId, communitySlug) => {
  return async (dispatch, getState) => {
    dispatch({ type: actionTypes.FETCH_POST });
    try {
      const api = createAuthenticatedApiInstance(getState);
      const { data } = await api.getPublic(`posts/${communitySlug}/${postId}`);

      const post = enrichDataObject(data, data.mentionedUsers);
      const responses = (post.responses || []).map(response => enrichDataObject(response, data.mentionedUsers));

      dispatch({
        type: actionTypes.FETCH_POST_SUCCESS,
        post: {
          ...post,
          responses,
        },
      });
    } catch (ex) {
      log.error(ex);
      dispatch({ type: actionTypes.FETCH_POST_FAILURE, error: ex });
      dispatch(setAlert(ex.message));
    }
  };
};

export const fetchPrivatePost = (postId, communitySlug) => {
  return async (dispatch, getState) => {
    dispatch({ type: actionTypes.FETCH_POST });
    try {
      const api = createAuthenticatedApiInstance(getState);
      const { data } = await api.get(`private/posts/${communitySlug}/${postId}`);

      const post = enrichDataObject(data, data.mentionedUsers);
      const responses = (post.responses || []).map(response => enrichDataObject(response, data.mentionedUsers));

      dispatch({
        type: actionTypes.FETCH_POST_SUCCESS,
        post: {
          ...post,
          responses,
        },
      });
    } catch (ex) {
      log.error(ex);
      dispatch({ type: actionTypes.FETCH_POST_FAILURE, error: ex });
      dispatch(setAlert(ex.message));
    }
  };
};

export const fetchPopularPosts = (postId, communitySlug) => {
  return async (dispatch, getState) => {
    dispatch({ type: actionTypes.FETCH_POPULAR_POSTS });
    try {
      const api = createAuthenticatedApiInstance(getState);
      const { data } = await api.getPublic(`posts/${communitySlug}/popular`);

      const posts = data.slice(0, 5).map(post => ({
        postId: post.postId,
        title: post.title,
        userImageHash: post.author.userImageHash,
        username: post.author.username,
        postTypeId: post.postTypeId,
      }));

      dispatch({
        type: actionTypes.FETCH_POPULAR_POSTS_SUCCESS,
        posts,
      });

    } catch (ex) {
      log.error(ex);
      dispatch({ type: actionTypes.FETCH_POPULAR_POSTS_FAILURE, error: ex });
    }
  };
};

export const fetchTopics = (communitySlug) => {
  return async (dispatch) => {
    dispatch({ type: actionTypes.FETCH_TOPICS });
    try {
      const { data } = await api.getPublic(`topics/${communitySlug}`);
      const topics = data.map(topic => ({
        id: topic.topicId,
        name: topic.name,
        postCount: topic.postCount,
      }));

      dispatch({
        type: actionTypes.FETCH_TOPICS_SUCCESS,
        topics,
      });
    } catch (ex) {
      dispatch({ type: actionTypes.FETCH_TOPICS_FAILURE, error: ex });
      dispatch(setAlert(ex.message));
    }
  };
};

export const fetchPinnedPosts = (communitySlug) => {
  return async (dispatch, getState) => {
    dispatch({ type: actionTypes.FETCH_PINNED_POSTS });
    try {
      const api = createAuthenticatedApiInstance(getState);
      const { data } = await api.getPublic(`posts/${communitySlug}/pinned`);

      const posts = data.slice(0, 5).map(post => ({
        postId: post.postId,
        title: post.title,
        userImageHash: post.author.userImageHash,
        username: post.author.username,
        postTypeId: post.postTypeId,
      }));

      dispatch({
        type: actionTypes.FETCH_PINNED_POSTS_SUCCESS,
        posts,
      });

    } catch (ex) {
      log.error(ex);
      dispatch({ type: actionTypes.FETCH_PINNED_POSTS_FAILURE, error: ex });
    }
  };
};

export const fetchPrivatePinnedPosts = (communitySlug) => {
  return async (dispatch, getState) => {
    dispatch({ type: actionTypes.FETCH_PINNED_POSTS });
    try {
      const api = createAuthenticatedApiInstance(getState);
      const { data } = await api.get(`private/posts/${communitySlug}/pinned`);

      const posts = data.slice(0, 5).map(post => ({
        postId: post.postId,
        title: post.title,
        userImageHash: post.author.userImageHash,
        username: post.author.username,
        postTypeId: post.postTypeId,
      }));

      dispatch({
        type: actionTypes.FETCH_PINNED_POSTS_SUCCESS,
        posts,
      });

    } catch (ex) {
      log.error(ex);
      dispatch({ type: actionTypes.FETCH_PINNED_POSTS_FAILURE, error: ex });
    }
  };
};

export const fetchRelatedPosts = (postId, communitySlug) => {
  return async (dispatch, getState) => {
    dispatch({ type: actionTypes.FETCH_RELATED_POSTS });
    try {
      const api = createAuthenticatedApiInstance(getState);
      const { data } = await api.getPublic(`posts/${communitySlug}/${postId}/related`);

      const posts = data.map(post => enrichDataObject(post));

      dispatch({
        type: actionTypes.FETCH_RELATED_POSTS_SUCCESS,
        posts,
      });

    } catch (ex) {
      log.error(ex);
      dispatch({ type: actionTypes.FETCH_RELATED_POSTS_FAILURE });
    }
  };
};

export const fetchPrivateRelatedPosts = (postId, communitySlug) => {
  return async (dispatch, getState) => {
    dispatch({ type: actionTypes.FETCH_RELATED_POSTS });
    try {
      const api = createAuthenticatedApiInstance(getState);
      const { data } = await api.get(`private/posts/${communitySlug}/${postId}/related`);

      const posts = data.map(post => enrichDataObject(post));

      dispatch({
        type: actionTypes.FETCH_RELATED_POSTS_SUCCESS,
        posts,
      });

    } catch (ex) {
      log.error(ex);
      dispatch({ type: actionTypes.FETCH_RELATED_POSTS_FAILURE });
    }
  };
};

export const fetchNextPosts = (postId, date, communitySlug) => {
  return async (dispatch, getState) => {
    dispatch({ type: actionTypes.FETCH_NEXT_POSTS });
    try {
      const api = createAuthenticatedApiInstance(getState);
      const { data } = await api.getPublic(`posts/${communitySlug}/${postId}/next`, {
        params: {
          pageSize: 30,
          CreatedBefore: date,
        },
      });

      const posts = data.map(post => enrichDataObject(post));

      dispatch({
        type: actionTypes.FETCH_NEXT_POSTS_SUCCCESS,
        posts,
      });

    } catch (ex) {
      dispatch({ type: actionTypes.FETCH_NEXT_POSTS_FAILURE, error: ex });
    }
  };
};

export const fetchPrivateNextPosts = (postId, date, communitySlug) => {
  return async (dispatch, getState) => {
    dispatch({ type: actionTypes.FETCH_NEXT_POSTS });
    try {
      const api = createAuthenticatedApiInstance(getState);
      const { data } = await api.get(`private/posts/${communitySlug}/${postId}/next`, {
        params: {
          pageSize: 30,
          CreatedBefore: date,
        },
      });

      const posts = data.map(post => enrichDataObject(post));

      dispatch({
        type: actionTypes.FETCH_NEXT_POSTS_SUCCCESS,
        posts,
      });

    } catch (ex) {
      dispatch({ type: actionTypes.FETCH_NEXT_POSTS_FAILURE, error: ex });
    }
  };
};
